import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { AvailabilityIconWithDotBadge } from 'shared/components';
import { AVAILABLE, AWAY, UNAVAILABLE } from 'modules/common/constants/userAvailabilityTypes';

import theme from './DetailsInfoRow.scss';

const propTypes = {
  availability: PropTypes.oneOf([AWAY, UNAVAILABLE, AVAILABLE]),
  iconName: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  initials: PropTypes.string,
  avatar: PropTypes.string,
  descriptionSize: PropTypes.string,
  additionalInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  withBorder: PropTypes.bool,
  insidePanel: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isWrapped: PropTypes.bool,
  isExpandable: PropTypes.bool,
  isMasked: PropTypes.bool,
  isPhoneNumber: PropTypes.bool,
  isPatientInWaitingRoom: PropTypes.bool,
};

const defaultProps = {
  availability: null,
  iconName: null,
  title: null,
  description: null,
  initials: undefined,
  avatar: undefined,
  descriptionSize: undefined,
  withBorder: false,
  insidePanel: false,
  additionalInfo: null,
  isDisabled: false,
  isWrapped: false,
  isExpandable: false,
  isMasked: false,
  isPhoneNumber: false,
  isPatientInWaitingRoom: false,
};

const DetailsInfoRow = ({
  availability,
  iconName,
  title,
  description,
  initials,
  avatar,
  descriptionSize,
  additionalInfo,
  withBorder,
  insidePanel,
  isDisabled,
  isWrapped,
  isExpandable,
  isMasked,
  isPhoneNumber,
  isPatientInWaitingRoom,
}) => (
  <div className={ classnames(theme.row, {
      [theme.withBorder]: withBorder,
      [theme.insidePanel]: insidePanel,
    }) }
  >
    <div className={ classnames(theme.icon, {
        [theme.insidePanel]: insidePanel,
      }) }
    >
      <AvailabilityIconWithDotBadge
        availability={ availability }
        name={ iconName }
        userInfo={ isMasked ? null : { avatar, initials } }
        withoutBackground={ insidePanel }
        iconWidth={ !insidePanel ? '40px' : undefined }
        iconFontSize={ !insidePanel ? '26px' : undefined }
        titleFontSize={ !insidePanel ? '20px' : undefined }
        isDisabled={ isDisabled }
      />
    </div>
    <div
      className={ classnames(theme.info, {
        [theme.isExpandable]: isExpandable,
      }) }
      tabIndex={ 0 }
    >
      <div className={ theme.title }>
        { title }
      </div>
      <div
        className={ classnames(descriptionSize === 'small' ? theme.smallDescription : theme.headerDescription, {
          [theme.isWrapped]: isWrapped,
          [theme.isPhoneNumber]: isPhoneNumber,
        }) }
      >
        { isMasked ? '*****' : description }
      </div>
      <If condition={ isPatientInWaitingRoom }>
        <div className={ classnames(theme.additionalInfo, theme.inWaitingRoom) }>
          <FormattedMessage
            id="Appointment.List.UserAvailability.InWaitingRoom"
            defaultMessage="** In waiting room"
          />
        </div>
      </If>

      <If condition={ additionalInfo }>
        <div className={ theme.additionalInfo }>
          { isMasked ? '*****' : additionalInfo }
        </div>
      </If>
    </div>
  </div>
);

DetailsInfoRow.propTypes = propTypes;
DetailsInfoRow.defaultProps = defaultProps;

export default DetailsInfoRow;
